import { render, staticRenderFns } from "./PuzzleDetail.vue?vue&type=template&id=508564d4"
import script from "./PuzzleDetail.vue?vue&type=script&lang=js"
export * from "./PuzzleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports